import { Controller } from "@hotwired/stimulus"
import ConsentService from "../services/consent_service"

export default class extends Controller {

  static targets = ["rgpdConsent"]

  updateConsent(event) {
    const consentValue = event.target.checked;
    ConsentService.updateConsent(consentValue);
  }
}
